import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const BulkBookingCardWrapper = styled.section`
  width: 1200px;
  margin: 0 auto 0;
  background: ${theme.whiteText};
  border-radius: 16px;
  padding: 32px 32px 32px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  box-sizing: border-box;
`;

export const ContentCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  font-size: 32px;
  font-weight: 900;
  color: ${theme.blackText};
  line-height: normal;
`;

export const NewIcon = styled.img`
  height: 21px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
`;

export const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: normal;
  width: 100%;
  max-width: 892px;
`;

export const IconCol = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;

  img {
    display: block;
    max-width: 112px;
    max-height: 83px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`;
